import { render, staticRenderFns } from "./u-tooltip-elevation-rounded.vue?vue&type=template&id=9739ec3a&scoped=true"
import script from "./u-tooltip-elevation-rounded.vue?vue&type=script&lang=js"
export * from "./u-tooltip-elevation-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9739ec3a",
  null
  
)

export default component.exports